<template>
    <v-container>
        <v-simple-form title="公章信息">
            <template v-slot:toolbar>
                <v-btn text tile small color="rgba(0,0,0,.7)" @click="goBack">
                    <v-icon color="gray">mdi-step-backward</v-icon>
                    返回
                </v-btn>
                <v-btn text tile small color="rgba(0,0,0,.7)" @click="onSave">
                    <v-icon color="gray">mdi-content-save</v-icon>
                    保存
                </v-btn>
                <v-spacer/>
            </template>
            <template v-slot:content>
                <v-form-field x-large v-model="dataItem.name" label="公章名称"></v-form-field>
                <v-form-textarea x-large v-model="dataItem.description" label="描述"></v-form-textarea>
                <v-form-file @uploaded="onUploaded" x-large v-model="dataItem.imageUrl" return-url
                             label="上传公章图片"></v-form-file>
                <v-form-image :url="dataItem.imageUrl" :height="parseInt(dataItem.height)" :width="parseInt(dataItem.width)"  v-if="dataItem.imageUrl"></v-form-image>
                <v-form-field x-large v-model="dataItem.width" label="图片长"></v-form-field>
                <v-form-field x-large v-model="dataItem.height" label="图片高"></v-form-field>
            </template>
        </v-simple-form>
    </v-container>
</template>

<script>

    export default {
        name: "ProjectDetail.vue",
        data() {
            return {
                docId: null,
                deployLog: null,
                showDeployLogDialog: null,
                dataItem: {
                    id: null,
                    name: null,
                    imageUrl: null,
                    imageId: null,
                    height: null,
                    width: null,
                    description: null,
                }
            }
        },
        created() {
            this.docId = this.$route.query.id;
            if (this.docId) {
                this.queryDetail(this.docId);
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            onSave() {
                this.$request
                    .request("SEAL_APPLY", this.dataItem)
                    .then((response) => {
                        this.$message.success("保存成功");
                        if (!this.docId) {
                            this.goBack();
                        }
                    });
            },
            onUploaded(items) {
                if (items && items.length > 0) {
                    this.dataItem.imageId = items[0].uuid;
                    var image = new Image();
                    let item = this.dataItem;
                    image.onload = function () {
                        item.height = this.height;
                        item.width = this.width;
                    }
                    image.src = items[0].url;
                }
            },
            queryDetail(id) {
                this.$request
                    .request("SEAL_DETAIL", {rowid: id})
                    .then(response => {
                        this.dataItem = Object.assign(this.dataItem, response.data)
                    });
            }
        }
    }
</script>